import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import "./assets/css/main.css";
import "./assets/css/util.css";
import Particles from "vue-particles";
import Element from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/theme/index.scss";
import "../public/css/main.css";
import "../public/css/util.css";
import url from "./Base"; // 导入基础路径
Vue.prototype.$axios = axios;
Vue.prototype.URL = url;
axios.defaults.baseURL = url.BASE_URL; // 全局URL
// axios.defaults.baseURL = "/api"; // 全局URL

// 说明：访问统计 tracker.js 只在官网（ccndt-website 生成的静态页）接入，
// 后台管理操作的页面访问不写入 cn_visit_log。

import less from "less";
Vue.use(less);

import validator from "@/utils/validate";
Vue.use(validator);

import "@/views/components/common/directives"; // 弹框拖动

import swal from "sweetalert"; // 弹出层
// 注册富文本编辑器
import tinymce from "tinymce";
Vue.prototype.$tinymce = tinymce;

// 全局修改表头样式
Vue.prototype.getRowClass = function () {
  return "background:#f0f4fb;line-height:26px;color:#555;font-weight:bold;";
};
Vue.prototype.getRowClass2 = function () {
  return "background:#c8dced;line-height:26px;color:#555;font-weight:bold;padding:0";
};
Vue.use(Particles);
Vue.use(Element);
Vue.config.productionTip = false;
Vue.prototype.bus = new Vue();

new Vue({
  router,
  store,
  swal,
  render: h => h(App),
}).$mount("#app");
